// import loadScript from "@/utils/loadScript";
export const registerMonitor = function (project: string, pureUrl = false) {
  if (!window.monitor) {
    return false;
  }
  let url = pureUrl ? location.href.split("?")[0] : location.href;
  if (project === "QH_132_7") {
    url = url.replace(/&mid1=.*?&mid2=.*/, "");
  }
  monitor
    .setProject(project, {
      tab: window.navigator && window.navigator.userAgent,
    })
    .setUrl(url)
    .getTrack()
    .getClickAndKeydown()
    .getClickHeatmap(10, 1);
};

// 商城打点需要备份给服务端
export const sendMonitorToServer = function () {
  if (!window.monitor) {
    return false;
  }
  const originalSendLog = window.monitor.sendLog;
  monitor.sendLog = (url: string) => {
    const buildCustomUrl = (url: string) =>
      url.replace("//s.360.cn", "//api.soft.360.cn");
    const customURL = buildCustomUrl(url);
    originalSendLog(url);
    originalSendLog(customURL);
  };
};

export const registerMonitorV2 = function (project: string, pureUrl = false) {
  if (!window.RADAR_MONITOR) {
    return false;
  }
  const url = pureUrl ? location.href.split("?")[0] : location.href;
  RADAR_MONITOR.setProject(project, {
    tab: window.navigator && window.navigator.userAgent,
  })
    .getAutoTrack()
    // .getClickAndKeydown()
    .getClickHeatmap(10, 1)
    .setUrl(url);
};

export const sendClkLog = function (params: object, evtName: string) {
  try {
    RADAR_MONITOR.log(params, evtName); //发送点击统计
  } catch (e) {
    console.log("error", e);
  }
};

export const resetOldMonitor = function () {
  // window.monitor = null;
  if (!window.monitor) {
    return false;
  }
  window!.monitor!.log = function () {};
  window!.monitor!.data!.getClick = function () {}; // fix 老版sdk 自动采集行为
};
